export default class Scraper {

  constructor(scraper = {}) {
    this.id = scraper.id || null
    this.name = scraper.name || ''
    this.description = scraper.description || ''
    this.handler_example = scraper.handler_example || ''
    this.attribute_types = scraper.attribute_types || []
    this.payload_type = scraper.payload_type || {}
    this.scraper = scraper.scraper || ''
    this.handler_type = scraper.handler_type || ''
    this.type = scraper.type || ''
    this.return_value = scraper.return_value || ''
    this.scrapes_on_client = scraper.scrapes_on_client || false
  }

  static mutations() {
    return {
      setScraper: (state, payload) => state.scraper = new Scraper(payload),
      updateName: (state, payload) => state.scraper.name = payload,
      updateDescription: (state, payload) => state.scraper.description = payload,
      updateHandlerExample: (state, payload) => state.scraper.handler_example = payload,
      toggleClientSideScraping: (state, payload) => state.scraper.scrapes_on_client = payload,
      updateScraper: (state, payload) => state.scraper.scraper = payload,
      updatePayload: (state, payload) => state.scraper.payload_type = payload,
      updateReturnValue: (state, payload) => state.scraper.return_value = payload,
    }
  }

}